import { render, staticRenderFns } from "./BroadcastList.vue?vue&type=template&id=3ed2032d&scoped=true&"
import script from "./BroadcastList.vue?vue&type=script&lang=ts&"
export * from "./BroadcastList.vue?vue&type=script&lang=ts&"
import style0 from "./BroadcastList.vue?vue&type=style&index=0&id=3ed2032d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed2032d",
  null
  
)

export default component.exports